export default "__VITE_ASSET__BQWYP3_X__"